import { ChangeDetectionStrategy, Component, ViewEncapsulation, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InputComponent } from '../input/input.component';
import { FormControl, ReactiveFormsModule } from '@angular/forms';

@Component({
  selector: 'orbit-form-field',
  standalone: true,
  imports: [CommonModule, InputComponent, ReactiveFormsModule],
  templateUrl: './form-field.component.html',
  styleUrl: './form-field.component.scss',
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FormFieldComponent {
  label = input<string>();
  inputType = input<'text' | 'number' | 'email' | 'password' | 'textarea'>('text');
  name = input<string>('');
  autocomplete = input<boolean>(true);
  placeholder = input<string>();
  defaultController = new FormControl<string | null>(null);
  controller = input<FormControl>(this.defaultController);
  disabled = input<boolean>(false);
  testId = input<string>();
}
